export default "__VITE_ASSET__CexkFQIF__"